export default __webpack_public_path__ + "static/media/guilhem.2fdc590e.png";